import {BleCharacteristic, BleClient, BleDevice, BleService} from "@capacitor-community/bluetooth-le";
import {Assert} from "js-vextensions";

class BluetoothRemoteGATTCharacteristic_Fake implements BluetoothRemoteGATTCharacteristic {
	constructor(service: BluetoothRemoteGattService_Fake, characteristic: BleCharacteristic) {
		this.service = service;
		this.characteristic = characteristic;
		console.log("Creating BluetoothRemoteGATTCharacteristic_Fake:", this.characteristic, this);
	}
	service?: BluetoothRemoteGATTService | undefined;
	characteristic: BleCharacteristic;

	get uuid(): string { return this.characteristic.uuid; }
	get properties(): BluetoothCharacteristicProperties {
		const p = this.characteristic.properties;
		return {
			read: p.read,
			write: p.write,
			writeWithoutResponse: p.writeWithoutResponse,
			notify: p.notify,
			indicate: p.indicate,
			broadcast: p.broadcast,
			//authenticateEncryption: p.authenticateEncryption,
			extendedProperties: p.extendedProperties,
			reliableWrite: p.reliableWrite,
			writableAuxiliaries: p.writableAuxiliaries,
			//encryptRead: p.encryptRead,
			//encryptWrite: p.encryptWrite,
			//encryptAuthenticatedRead: p.encryptAuthenticatedRead,
			//encryptAuthenticatedWrite: p.encryptAuthenticatedWrite,
			authenticatedSignedWrites: p.authenticatedSignedWrites,
		} as BluetoothCharacteristicProperties;
	}

	//value?: DataView<ArrayBufferLike> | undefined;
	value?: DataView | undefined;
	getDescriptor(descriptor: BluetoothDescriptorUUID): Promise<BluetoothRemoteGATTDescriptor> {
		Assert(false, "Method not implemented.");
	}
	getDescriptors(descriptor?: BluetoothDescriptorUUID): Promise<BluetoothRemoteGATTDescriptor[]> {
		Assert(false, "Method not implemented.");
	}
	readValue(): Promise<DataView> {
		Assert(false, "Method not implemented.");
	}
	async writeValue(value: BufferSource): Promise<void> {
		console.log("Writing:", value, this);
		/*const valueAsDataView =
		 	value instanceof DataView ? value :
		 	value["buffer"] && value["byteOffset"] != null && value["byteLength"] != null ? new DataView(value["buffer"], value["byteOffset"], value["byteLength"]) :
		 	new DataView(value as ArrayBufferLike);*/
		const valueAsDataView = value as any;
		console.log("About to write value:", valueAsDataView, this);
		await BleClient.writeWithoutResponse(this.service!.device.id, this.service!.uuid, this.uuid, valueAsDataView);
		// TODO: ensure writeWithoutResponse is always correct here (write didn't work in initial case, but may need conditional handling)
		console.log("Wrote value:", valueAsDataView, this);
	}
	async startNotifications(): Promise<BluetoothRemoteGATTCharacteristic> {
		console.log("Starting notifications for characteristic:", this.uuid, this);
		await BleClient.startNotifications(this.service!.device.id, this.service!.uuid, this.uuid, value=>{
			const dataView = new DataView(value.buffer, value.byteOffset, value.byteLength);
			this.value = dataView;
			//console.log("Got value!:", dataView);
			const ev = new Event("characteristicvaluechanged");
			//(ev as any).target = this; // set target to this characteristic
			Object.defineProperty(ev, "target", {
				value: this,
				writable: false,
				enumerable: true,
				configurable: false
			 });
			this.custom.eventListeners.characteristicvaluechanged.forEach(a=>a.call(this, ev));
		});
		return this;
	}
	stopNotifications(): Promise<BluetoothRemoteGATTCharacteristic> {
		Assert(false, "Method not implemented.");
	}
	addEventListener(type: unknown, listener: unknown, useCapture?: unknown): void {
		this.custom.eventListeners[type as string].push(listener as any);
	}
	dispatchEvent(event: Event): boolean {
		Assert(false, "Method not implemented.");
	}
	removeEventListener(type: string, callback: EventListenerOrEventListenerObject | null, options?: EventListenerOptions | boolean): void {
		this.custom.eventListeners[type].Remove(callback as any);
	}
	oncharacteristicvaluechanged: (this: BluetoothRemoteGATTCharacteristic, ev: Event) => any; // TODO

	custom = {
		eventListeners: {
			characteristicvaluechanged: [] as ((this: BluetoothRemoteGATTCharacteristic_Fake, ev: Event)=>any)[],
		},
	}
	// return simplified json representation (otherwise errors in custom console.log override)
	toJSON() { return "<v-fix-for-console-log>"; }
}

class BluetoothRemoteGattService_Fake implements BluetoothRemoteGATTService {
	constructor(gatt: BluetoothRemoteGATTServer_Fake, service: BleService, serviceUUID: string) {
		this.device = gatt.device;
		this.gatt = gatt;
		this.service = service;
		this.uuid = serviceUUID;
	}
	device: BluetoothDevice;
	gatt: BluetoothRemoteGATTServer_Fake;
	service: BleService;

	isPrimary: boolean;
	getCharacteristic(characteristic: BluetoothCharacteristicUUID): Promise<BluetoothRemoteGATTCharacteristic> {
		Assert(false, "Method not implemented.");
	}
	async getCharacteristics(characteristic?: BluetoothCharacteristicUUID): Promise<BluetoothRemoteGATTCharacteristic[]> {
		return this.service.characteristics.map(a=>{
			return new BluetoothRemoteGATTCharacteristic_Fake(this, a);
		});
	}
	getIncludedService(service: BluetoothServiceUUID): Promise<BluetoothRemoteGATTService> {
		Assert(false, "Method not implemented.");
	}
	getIncludedServices(service?: BluetoothServiceUUID): Promise<BluetoothRemoteGATTService[]> {
		Assert(false, "Method not implemented.");
	}
	addEventListener(type: unknown, listener: unknown, useCapture?: unknown): void {
		Assert(false, "Method not implemented.");
	}
	dispatchEvent(event: Event): boolean {
		Assert(false, "Method not implemented.");
	}
	removeEventListener(type: string, callback: EventListenerOrEventListenerObject | null, options?: EventListenerOptions | boolean): void {
		Assert(false, "Method not implemented.");
	}
	oncharacteristicvaluechanged: (this: BluetoothRemoteGATTService, ev: Event) => any;
	onserviceadded: (this: BluetoothRemoteGATTService, ev: Event) => any;
	onservicechanged: (this: BluetoothRemoteGATTService, ev: Event) => any;
	onserviceremoved: (this: BluetoothRemoteGATTService, ev: Event) => any;
	uuid: string;
}

class BluetoothRemoteGATTServer_Fake implements BluetoothRemoteGATTServer {
	constructor(device: WebBluetoothWrapper) {
		this.device = device;
		this.connected = false;
	}

	device: BluetoothDevice;
	connected: boolean;
	async connect(): Promise<BluetoothRemoteGATTServer> {
		await BleClient.connect(this.device.id, deviceId=>{
			(this.device as WebBluetoothWrapper).custom.onGattServerDisconnected_listeners.forEach(a=>a.call(this.device, new Event("gattserverdisconnected")));
		});
		return this;
	}
	disconnect(): void {
		(async()=>{
			await BleClient.disconnect(this.device.id);
			// commented; handled in BleClient.connect() callback
			//this.device.custom.onGattServerDisconnected_listeners.forEach(a=>a.call(this.device, new Event("gattserverdisconnected")));
		})();
	}
	async getPrimaryService(serviceID: BluetoothServiceUUID): Promise<BluetoothRemoteGATTService> {
		//Assert(false, "Method not implemented.");
		let service: BleService|n;
		for (let i = 0; i < 10; i++) { // retry up to 10 times, in case of initial connection issues
			const services = await BleClient.getServices(this.device.id);
			service = services.find(s=>s.uuid == serviceID);
			if (service != null) break;
			console.warn(`Service with UUID ${serviceID} not found on device ${this.device.id}, retrying... (${i+1}/10)`);
			await new Promise(resolve=>setTimeout(resolve, 500)); // wait 500ms before retrying
		}
		if (service == null) {
			throw new Error(`Service with UUID ${service} not found on device ${this.device.id}`);
		}
		return new BluetoothRemoteGattService_Fake(this, service, service.uuid);
	}
	getPrimaryServices(service?: BluetoothServiceUUID): Promise<BluetoothRemoteGATTService[]> {
		Assert(false, "Method not implemented.");
	}
	addEventListener(type: string, callback: EventListenerOrEventListenerObject | null, options?: AddEventListenerOptions | boolean): void {
		Assert(false, "Method not implemented.");
	}
	dispatchEvent(event: Event): boolean {
		Assert(false, "Method not implemented.");
	}
	removeEventListener(type: string, callback: EventListenerOrEventListenerObject | null, options?: EventListenerOptions | boolean): void {
		Assert(false, "Method not implemented.");
	}
}

export class WebBluetoothWrapper implements BluetoothDevice {
	constructor(bleDevice: BleDevice) {
		this.bleDevice = bleDevice;
		this.gatt = new BluetoothRemoteGATTServer_Fake(this);
	}

	bleDevice: BleDevice;
	gatt?: BluetoothRemoteGATTServer | undefined;

	get id(): string { return this.bleDevice.deviceId; }
	get name(): string | undefined { return this.bleDevice.name; }
	get uuids(): string[] | undefined { return this.bleDevice.uuids;}

	watchAdvertisements(): Promise<void> {
		Assert(false, "Method not implemented.");
	}
	unwatchAdvertisements(): void {
		Assert(false, "Method not implemented.");
	}
	watchingAdvertisements: boolean;
	addEventListener(type: unknown, listener: unknown, useCapture?: unknown): void {
		if (type == "gattserverdisconnected") {
			this.custom.onGattServerDisconnected_listeners.push(listener as any);
			console.log("TODO: Ensure callers for onGattServerDisconnected_listeners are correct");
		} else {
			Assert(false, "Method not implemented.");
		}
	}
	dispatchEvent(event: Event): boolean {
		Assert(false, "Method not implemented.");
	}
	removeEventListener(type: string, callback: EventListenerOrEventListenerObject | null, options?: EventListenerOptions | boolean): void {
		Assert(false, "Method not implemented.");
	}
	ongattserverdisconnected: (this: BluetoothDevice, ev: Event) => any;
	oncharacteristicvaluechanged: (this: BluetoothDevice, ev: Event) => any;
	onserviceadded: (this: BluetoothDevice, ev: Event) => any;
	onservicechanged: (this: BluetoothDevice, ev: Event) => any;
	onserviceremoved: (this: BluetoothDevice, ev: Event) => any;

	custom = {
		onGattServerDisconnected_listeners: [] as ((this: BluetoothDevice, ev: Event)=>any)[],
	};
}

/*const a1: BluetoothDevice = null as any;
a1.addEventListener("gattserverdisconnected", (b, c, d)=>{
	console.log("gattserverdisconnected", b, c, d);
});*/